document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-prelaunch-countdown]').forEach(function (el) {
    var target = new Date(el.dataset.prelaunchCountdown).getTime();
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function update() {
      var diff = Math.max(0, target - Date.now());

      daysEl.textContent = pad(Math.floor(diff / 86400000));
      hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));

      if (diff <= 0) {
        clearInterval(interval);
      }
    }

    update();
    interval = setInterval(update, 1000);
  });
});
